import { owcTheme } from '@one/design-tokens/js/regular/navify/light';

/** Internal canvas resolution, also the size of the exported SVG sent to the backend. */
export const SIGNATURE_WIDTH = 288;
export const SIGNATURE_HEIGHT = 237;

export const SIGNATURE_MAX_RENDERED_WIDTH = 360;

/** Space left free on each side so the user can scroll the step without starting a stroke. */
export const SIGNATURE_SCROLL_MARGIN = owcTheme['one-spacing-base-4'];
